module.exports = __webpack_public_path__ + "img/__icon_HAKOWIEC.1ce5ddab.svg";